import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { useSiteContext } from "../common/SiteContext"
import { ContactCard, EContactCardLayout } from "@organic-return/foundation-react/src/components/Contact"
import { EListingCardLayouts, ListingCard } from "@organic-return/foundation-react/src/components/Listing"

export const NAILandmarkAgentsAndListings = ({ module }) => {
    const siteContext = useSiteContext()
    const data = useStaticQuery(graphql`
    query {
        allPerson(filter: {type: {eq: "commercial"}}) {
          nodes {
            photos {
              url
            }
            first
            last
            fullName
            workTitle
            designations
            phone
            phoneOffice
            phoneMobile
            email
            social {
              channel
              url
              text
            }
            path: personalWebsite
          }
        }
        allListing(
          filter: {type: {in: ["Commercial Sale", "Commercial Lease"]}, status: {ne: "Closed"}, exclusive: {eq: true}}
          sort: {fields: price, order: DESC}
          limit: 6
        ) {
          nodes {
            defaultImage {
              url
            }
            price
            baths
            beds
            sqft
            lotacres
            address {
              text
              street1
              street2
              city
              state
              postal
            }
            path
          }
        }
      }          
  `)
    const agents = data.allPerson?.nodes ?? []
    const listings = data.allListing?.nodes ?? []
    return (
        <div className="commercial-agents-module w-full mx-auto max-w-screen-xl px-2">
            {agents.length > 0 && (
                <>
                    <h2 className="w-full text-center pt-5 pb-6 leading-none">
                        Commercial
                        <span className="block font-body">Agents</span>
                    </h2>
                    <div className="w-full max-w-screen-lg mx-auto grid grid-cols-1 lg:grid-cols-3 gap-x-2.5 gap-y-4 pt-6">
                        {agents.map((item, index) => (
                            <ContactCard
                                contact={item}
                                layout={EContactCardLayout.horizontal}
                                maxWidthImage={200}
                                className="w-full sm:w-1/2 xl:w-1/3 p-4"
                                showVCard={false}
                                key={index}
                                linkFunc={props => {
                                    return (
                                        <a
                                            href={props.href ?? ""}
                                            className={`text-inherit ${props.className}`}
                                            key={props.key}
                                            title={props.title}
                                        >
                                            {props.children}
                                        </a>
                                    )
                                }}
                                {...siteContext.globalPeopleSearchCardProps}
                            />
                        ))}
                    </div>
                </>
            )}

            {listings.length > 0 && (
                <>
                    <h2 className="w-full text-center pt-5 pb-6 leading-none">
                        Commercial
                        <span className="block font-body">Listings</span>
                    </h2>
                    <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-7 gap-y-2.5">
                        {listings.map((item, index) => (
                            <ListingCard
                                key={index}
                                listing={item}
                                layout={EListingCardLayouts.vertical}
                                linkImage={true}
                                linkFunc={props => {
                                    return (
                                        <Link
                                            to={props.href ?? ""}
                                            className={`text-inherit ${props.className}`}
                                            key={props.key}
                                            title={props.title}
                                        >
                                            {props.children}
                                        </Link>
                                    )
                                }}
                                {...siteContext.globalListingCardProps}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    )
}

export default NAILandmarkAgentsAndListings